import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography, UtpCardModal } from 'common/components';

export const Benefits: React.FC<UtpCardModal> = ({ elementBlock = '', onClick }) => (
  <>
    <ModalHeader title="Изготовим и&nbsp;доставим заказ за&nbsp;10&nbsp;дней" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Мы&nbsp;бережно упакуем все материалы и&nbsp;доставим по&nbsp;адресу в&nbsp;удобное для вас время.
        Если хотите забрать заказ самостоятельно, просто согласуйте этот момент с&nbsp;нашим менеджером.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={elementBlock}
        elementName="Записаться на консультацию"
        elementText="От заказа до получения —10 дней"
        onClick={onClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
